import { IconButton } from "@/components/common";
import { BaseTableActionProps } from "..";

type Props = Readonly<
  BaseTableActionProps & {
    isActive: boolean;
    isLoading: boolean;
  }
>;

export const TableActivationToggler = ({ isActive, ...props }: Props) => {
  return (
    <IconButton
      {...props}
      icon={isActive ? "LockOpen" : "Lock"}
      className={isActive ? "text-tertiary" : "text-secondary"}
      aria-label={isActive ? "Desativar" : "Ativar"}
    />
  );
};
